import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'3'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>新疆石河子大学第一附属医院项目成功集成上线</h3>
          <div className='time'>发布时间：2026-08-31</div>
          <div className='newsCon-con'>
            <p>作为用友 BIP 原生适配产品，拥有完全自主知识产权的 AiPRT 招标采购系统，现已完成与用友的新疆石河子大学第一附属医院项目深度集成，并于 2026 年 8 月 31 日正式顺利上线。</p>
            <p>AiPRT 招标采购系统面向医疗机构采购业务全流程打造，深度贴合医院采购合规管控要求，覆盖采购计划、需求申报、抽取评审、开评标管理、结果公示、合同履约、物资验收、档案归档等核心业务环节。系统依托用友 BIP 数智底座能力，实现业务数据互通互联，打通预算、采购、合同、资产全业务链条，强化采购全过程留痕与风险预警，规范医院招标采购业务流程，提升采购工作透明度与运行效率。</p>
            <p>本次项目成功上线，标志着 AiPRT 系统在医疗机构场景落地再添标杆案例。后续我们将持续打磨产品能力，深化与用友 BIP 生态协同，为更多医疗卫生单位提供合规、高效、一体化的数字化采购解决方案。</p>
          </div>
        </div>
      </PageBox>
    </>
  );
}